import React, { Component } from 'react';
import sectiondata from '../../data/sections.json';
import parse from 'html-react-parser';

class OurService extends Component {


    render() {

        let publicUrl = process.env.PUBLIC_URL + '/'
        let imagealt = 'image'
        let data = sectiondata.aboutus


        return <div className="about-area pd-bottom-90">
            <div className="container">
                <div className="row">

                    <div className="col-lg-6 align-self-center">
                        <div className="section-title pd-left mb-0">
                            {/* <h5 className="sub-title">{data.subtitle}</h5> */}
                            <h2 className="title">{data.title}</h2>
                            <ul>
                                <li style={{listStyle : "none"}}> <i class="fa fa-check" style={{ fontSize: "17px", color: "orange" }}></i> 100% Transparent & Ethical Dealings</li>
                                <li style={{listStyle : "none"}}> <i class="fa fa-check" style={{ fontSize: "17px", color: "orange" }}></i> Direct Developer Partnerships (No Hidden Fees)</li>
                                <li style={{listStyle : "none"}}> <i class="fa fa-check" style={{ fontSize: "17px", color: "orange" }}></i> Multilingual Advisors (English, Hindi, Urdu, Arabic)</li>
                                <li style={{listStyle : "none"}}> <i class="fa fa-check" style={{ fontSize: "17px", color: "orange" }}></i> Global Client Base in Over 10 Countries</li>
                                <li style={{listStyle : "none"}}> <i class="fa fa-check" style={{ fontSize: "17px", color: "orange" }}></i> Free Property Consultation & Site Visit Arrangement</li>
                            </ul>
                            <div className="col-12 text-left mt-4">
                                <h5 className="mb-3">Ready to Start Your Dubai Property Journey?</h5>
                                <a className="btn btn-yellow" href="/contact" > Contact us today for a free consultation</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <div className="shape-image-list-wrap">
                            <div className="shape-image-list left-top">
                                <img className="shadow-img" src={publicUrl + data.image} alt={imagealt} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    }
}

export default OurService